import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ProjectContext } from "../ProjectContext";
import { formatAddress } from "../funcitons";
import { address } from "framer-motion/client";

const Dropdown = () => {
  const { disconnectNow, account } = useContext(ProjectContext);

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  // Handlers for hover
  const handleMouseEnter = () => {
    setIsDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    setIsDropdownVisible(false);
  };

  const handleMouseClick = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  return (
    <div
      className="p-relative d-inline-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleMouseClick}
    >
      <button
        
        className="tp-btn-black-2 tp_fade_bottom d-none d-md-block my-2"
      >
        {formatAddress(account)}
      </button>
      {isDropdownVisible && (
        <div className="dropwn-submenu">
          <Link
            to="/account"
            className=" submenu-one d-none d-md-block "
            
          >
            Dashboard
          </Link>
          <Link
            to="/"
            className=" submenu-one d-none d-md-block "
            onClick={disconnectNow}
          >
            Disconnect
          </Link>
        </div>
      )}
    </div>
  );
};

export default Dropdown;